export const getSubmitButtonDisableStatus = (state) => {
  let disable = false;
  const arr = Object.keys(state.sectionInfo)?.map((key) => state.sectionInfo?.[key]?.editMode);
  disable = arr.reduce((a, b) => (a || b), false);
  return disable;
};
